import { Title, Text, List, Section, Cell } from '@telegram-apps/telegram-ui';
import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../LanguageProvider';
// import { Icon28Stats } from '@telegram-apps/telegram-ui/dist/icons/28/stats';
import '@telegram-apps/telegram-ui/dist/styles.css';
import { initBackButton, useLaunchParams } from '@tma.js/sdk-react';

export const Homepage = () => {
  const BackButton = initBackButton();

  useEffect(() => {
    if (!window.Telegram?.WebApp) {
      return;
    }
    BackButton[0].hide();
  }, []);
  const { translate, setLanguage, language } = useLanguage();
  const lp = useLaunchParams();
  let platform = ['macos', 'ios'].includes(lp.platform) ? 'ios' : 'base';

  const insuranceItems = [
    {
      title: translate('homepage:green-card-title'),
      subtitle: translate('homepage:green-card-subtitle'),
      href: '/green-card',
      before: (
        <p
          style={{
            fontSize: '37px',
          }}
        >
          🚗
        </p>
      ),
      disabled: false,
    },
    {
      title: translate('homepage:rovignette-title'),
      subtitle: translate('homepage:rovignette-subtitle'),
      href: '/rovignette',
      before: (
        <p
          style={{
            fontSize: '37px',
          }}
        >
          🛣️
        </p>
      ),
      disabled: false,
    },
    {
      title: translate('homepage:rca-title'),
      subtitle: translate('homepage:rca-subtitle'),
      href: '/rca',
      before: (
        <p
          style={{
            fontSize: '37px',
          }}
        >
          🚙
        </p>
      ),
      disabled: false,
    },
  ];
  return (
    <>
      <div
        style={{
          background: 'var(--tgui--secondary_bg_color)',
          height: '100vh',
        }}
      >
        <div className="text-center">
          <div>
            <img
              src="./images/iasig-small-logo.png"
              className="max-w-20 mx-auto py-8"
              alt="iAsig logo"
            />
          </div>
          <Text>{translate('homepage:title')}</Text>
          <Title level="1" weight="1" className="py-1">
            iAsig
          </Title>
          <Text
            style={{
              color: 'var(--tgui--hint_color)',
            }}
          >
            {translate('homepage:subtitle')}
          </Text>
        </div>
        <List
          className="mt-20"
          style={{
            background: 'var(--tgui--secondary_bg_color)',
            padding: 10,
          }}
        >
          {insuranceItems.map((item, index) => (
            <Section>
              <Link to={item.href}>
                {' '}
                <Cell
                  style={{ borderRadius: platform === 'ios' ? '12px' : '' }}
                  className="section-bg-color"
                  key={index}
                  subtitle={item.subtitle}
                  before={item.before}
                  onClick={() =>
                    window!.Telegram!.WebApp.HapticFeedback.impactOccurred(
                      'heavy'
                    )
                  }
                  disabled={item.disabled}
                  after={
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      style={{ fill: 'var( --tgui--secondary_hint_color)' }}
                      height="13px"
                      width="13px"
                      version="1.1"
                      id="Layer_1"
                      viewBox="0 0 330 330"
                    >
                      <path
                        id="XMLID_222_"
                        d="M250.606,154.389l-150-149.996c-5.857-5.858-15.355-5.858-21.213,0.001  c-5.857,5.858-5.857,15.355,0.001,21.213l139.393,139.39L79.393,304.394c-5.857,5.858-5.857,15.355,0.001,21.213  C82.322,328.536,86.161,330,90,330s7.678-1.464,10.607-4.394l149.999-150.004c2.814-2.813,4.394-6.628,4.394-10.606  C255,161.018,253.42,157.202,250.606,154.389z"
                      />
                    </svg>
                  }
                >
                  {item.title}
                </Cell>
              </Link>
            </Section>
          ))}
        </List>
      </div>
    </>
  );
};
